export const ADVANCED_ONBOARDING = 'advancedOnboarding'
